import { render } from "./KeyValuePairCard.vue?vue&type=template&id=25b8fb2b&scoped=true"
import script from "./KeyValuePairCard.vue?vue&type=script&lang=js"
export * from "./KeyValuePairCard.vue?vue&type=script&lang=js"

import "./KeyValuePairCard.vue?vue&type=style&index=0&id=25b8fb2b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b8fb2b"]])

export default __exports__